import React, { useState, memo } from "react";
import { StyleSheet, View } from "react-native";

import CustomButton from "../../common/general/CustomButton/CustomButton";
import FilterDropdown from "../../common/TableControls/FilterDropdown";
import { AudienceType } from "../../../graphql/generated/graphql";

interface AnnouncementFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  targetAudience: string;
  onTargetAudienceChange: (audience: string) => void;
}

const filterTabs = [
  { key: "all", label: "All Announcements" },
  { key: "published", label: "Published" },
  { key: "scheduled", label: "Scheduled" },
  { key: "draft", label: "Drafts" },
];

const targetAudienceOptions = [
  { label: "All Audiences", value: "all" },
  { label: "Schoolwide", value: AudienceType.School },
  { label: "All Students", value: AudienceType.Students },
  { label: "All Faculty", value: AudienceType.Faculty },
  { label: "Specific Groups", value: AudienceType.SpecificGroups },
];

const AnnouncementFilters: React.FC<AnnouncementFiltersProps> = ({
  activeFilter,
  onFilterChange,
  targetAudience,
  onTargetAudienceChange,
}) => {
  const [targetDropdownOpen, setTargetDropdownOpen] = useState(false);

  return (
    <View style={styles.container}>
      {/* Filter Tabs */}
      <View style={styles.filterTabs}>
        {filterTabs.map((tab) => (
          <CustomButton
            key={tab.key}
            text={tab.label}
            size="s"
            styleType={activeFilter === tab.key ? "primaryTransparent" : "transparent"}
            onPress={() => onFilterChange(tab.key)}
            style={[styles.filterTab, activeFilter === tab.key && styles.activeFilterTab]}
            textStyle={[styles.filterTabText, activeFilter === tab.key && styles.activeFilterTabText]}
          />
        ))}
      </View>

      {/* Filter Controls */}
      <View style={styles.filterControls}>
        <View style={styles.filterGroup}>
          <FilterDropdown
            filterValue={targetAudience}
            setFilterValue={onTargetAudienceChange}
            filterDropdownOpen={targetDropdownOpen}
            setFilterDropdownOpen={setTargetDropdownOpen}
            filterItems={targetAudienceOptions}
            label="target_audience"
            placeholder="All Audiences"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 16,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    zIndex: 10,
  },
  filterTabs: {
    flexDirection: "row",
    gap: 8,
  },
  filterTab: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    backgroundColor: "#FFFFFF",
  },
  activeFilterTab: {
    backgroundColor: "#3E68FE",
    borderColor: "#3E68FE",
  },
  filterTabText: {
    color: "#475467",
    fontSize: 14,
    fontWeight: "500",
  },
  activeFilterTabText: {
    color: "#FFFFFF",
  },
  filterControls: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    zIndex: 10,
  },
  filterGroup: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  filterLabel: {
    color: "#374151",
    fontWeight: "500",
  },
});

export default AnnouncementFilters;
